import consola from 'consola'
import { useSystemBackAction } from '@features/app-shell'

export default defineNuxtPlugin(async (nuxtApp) => {
  if (!process.client) {
    return
  }

  const cleanupCallbacks: Array<() => void> = []
  const { handleSystemBackAction } = useSystemBackAction(nuxtApp.$pinia)

  const onBackRequested = () => {
    const handled = handleSystemBackAction()
    if (!handled) {
      consola.info('[system-back] Нет состояний для возврата')
    }
  }

  const registerIosSwipeListener = () => {
    window.addEventListener('iosSwipeBack', onBackRequested)
    cleanupCallbacks.push(() => window.removeEventListener('iosSwipeBack', onBackRequested))
  }

  const registerAndroidBackListener = async () => {
    const { Capacitor } = await import('@capacitor/core')
    if (!Capacitor.isNativePlatform()) {
      return
    }

    const { App } = await import('@capacitor/app')
    const listener = await App.addListener('backButton', () => {
      onBackRequested()
    })

    cleanupCallbacks.push(() => {
      listener.remove()
    })
  }

  nuxtApp.hook('app:mounted', async () => {
    registerIosSwipeListener()
    await registerAndroidBackListener()
  })

  nuxtApp.hook('app:unmounted', () => {
    for (const fn of cleanupCallbacks) fn()
    cleanupCallbacks.length = 0
  })
})

